import React from "react";
import { Table as AntTable } from "antd";

function Table({ columns, dataSource }) {
  // console.log(dataSource, "dataSource");
  return <AntTable columns={columns} dataSource={dataSource} />;
}

export default Table;
